import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyUnitOfMeasurement = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [contents, setcontents] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        ReadAxios({ url: `unitOfMeasurement/` })
            .then((result) => {
                result?.data ? setcontents(result.data.resultSet) : setcontents([])
                setloading(false)
                if(props.uom_name && result.data.resultSet.length > 0){
                    let uomName = result.data.resultSet.find((op)=>op.unit.toUpperCase()===props.uom_name.toUpperCase())?.unit
                    setFieldValue(name, uomName)
                }
            })
    }, [])

    let options = []
    if (contents && contents.length > 0) {
        contents.map((object, index) => {
            let temp = {}
            temp.key = object.uomId
            temp.text = object.unit
            temp.value = object.unit
            return options[index] = temp
        })
    }
    return (
        <Dropdown
            selection
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={(value, data) => {
                setFieldValue(name, data.value)
                props.onChangeExtra && props.onChangeExtra()
            }}
            options={options}
            {...props}
        />

    )
}

export default MyUnitOfMeasurement